import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  GetTermsAndConditionsResp,
  TermsAndConditionsContentDto,
  TermsAndConditionsDto,
} from '../types/dto/terms-and-conditions'
import {
  TermsAndConditionsContentModel,
  TermsAndConditionsModel,
} from '../types/model/terms-and-conditions'

export type GetTermsAndConditionsContentResp = TermsAndConditionsContentDto

export const transformTermsAndConditionsContentDto = (
  dto: TermsAndConditionsContentDto,
): TermsAndConditionsContentModel => ({
  title: dto.title,
  text: dto.text,
  updates: {
    title: dto.updates?.title,
    text: dto.updates?.text,
  },
  additionalActions: dto?.additional_actions,
})

export const transformTermsAndConditionsDto = (
  dto: TermsAndConditionsDto,
): TermsAndConditionsModel => ({
  canAgree: dto.can_agree,
  canSkip: dto.can_skip,
  canAccept: dto.can_accept,
  agreementsUrl: dto.agreements_url,
})

export const transformTermsAndConditionsContentResponse = (
  response: Response<GetTermsAndConditionsContentResp>,
) => transformTermsAndConditionsContentDto(response)

export const transformTermsAndConditionsResponse = (
  response: Response<GetTermsAndConditionsResp>,
) => transformTermsAndConditionsDto(response.terms_and_conditions)
